import styled from 'styled-components'

const ZestawienieHeaderStyle = styled.div`
  grid-area: main;

  .list-header {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto auto auto auto;
    grid-template-areas: 'name a b b1 swap';

    padding: 0px 0 4px 20px;
    font-size: 11px;
    line-height: 1.45;
    letter-spacing: 0.4px;
    color: ${props => props.theme.black38};
  }

  .name {
    display: flex;
    align-items: center;
  }

  .column-title {
    display: flex;
    width: 136px;
    align-items: center;
    justify-content: flex-end;
    margin-left: 16px;
  }

  .third.column-title {
    grid-area: b1;
    text-align: right;
  }

  .swapper {
    width: 32px;
    grid-area: swap;
    margin-left: 16px;
  }

  .swap {
    width: 24px;
    height: 21px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  [role='tooltip'] {
    z-index: 2;
  }

  .checkbox-label {
    height: 24px;
    margin: 12px 0;
  }
`
export default ZestawienieHeaderStyle
